import { AlertCircle } from "lucide-react";
import { useThemeContext } from "../../../../context/ThemeContext";

const AssessmentBanner = ({ assessmentSetup }) => {
  const { darkMode } = useThemeContext();

  return (
    <div
      className={`sticky top-0 z-10 p-4 mb-4 rounded-lg border ${
        darkMode
          ? "bg-gray-800 border-gray-700 shadow-lg"
          : "bg-white border-gray-200 shadow-md"
      }`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center">
          <AlertCircle
            size={18}
            className={`mr-2 flex-shrink-0 ${
              darkMode ? "text-blue-400" : "text-blue-600"
            }`}
          />
          <p
            className={`text-sm font-semibold ${
              darkMode ? "text-gray-100" : "text-gray-800"
            }`}
          >
            Assessment Structure
          </p>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mb-3">
        <span
          className={`text-xs px-2 py-1 rounded-md font-medium ${
            darkMode
              ? "bg-blue-900/30 text-blue-300"
              : "bg-blue-100 text-blue-700"
          }`}
        >
          {assessmentSetup.assignments} Assignment
          {assessmentSetup.assignments !== 1 ? "s" : ""}
        </span>
        <span
          className={`text-xs px-2 py-1 rounded-md font-medium ${
            darkMode
              ? "bg-purple-900/30 text-purple-300"
              : "bg-purple-100 text-purple-700"
          }`}
        >
          {assessmentSetup.classTests} Class Test
          {assessmentSetup.classTests !== 1 ? "s" : ""}
        </span>
        <span
          className={`text-xs px-2 py-1 rounded-md font-medium ${
            darkMode
              ? "bg-amber-900/30 text-amber-300"
              : "bg-amber-100 text-amber-700"
          }`}
        >
          {assessmentSetup.projects} Project
          {assessmentSetup.projects !== 1 ? "s" : ""}
        </span>
        <span
          className={`text-xs px-2 py-1 rounded-md font-medium ${
            assessmentSetup.includePRS
              ? darkMode
                ? "bg-emerald-900/30 text-emerald-300"
                : "bg-emerald-100 text-emerald-700"
              : darkMode
                ? "bg-gray-700 text-gray-400"
                : "bg-gray-200 text-gray-600"
          }`}
        >
          PRS: {assessmentSetup.includePRS ? "Yes" : "No"}
        </span>
      </div>

      <div className="flex items-start pt-3 border-t border-gray-200 dark:border-gray-700">
        <p
          className={`text-xs ${darkMode ? "text-gray-400" : "text-gray-600"}`}
        >
          <span
            className={`font-medium ${darkMode ? "text-gray-300" : "text-gray-800"}`}
          >
            Note:{" "}
          </span>
          Data saves during navigation. Refresh/exit will lose unsaved changes.
        </p>
      </div>
    </div>
  );
};

export default AssessmentBanner;
